import React, { FC } from 'react';
import { withTooltip } from '../../hoc';
import { IconButton as ChakraUiIconButton } from '@chakra-ui/react';
import { ButtonProps } from '../Button';
import { Icon as CoreIcon, IconProps as CoreIconProps } from '../Icon';

interface Props extends ButtonProps {
  ariaLabel: string;
  icon: CoreIconProps;
  isRound?: boolean;
}
export const IconButton: FC<Props> = React.forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const { icon, ariaLabel, isActive, size, isFullWidth, ...rest } = props;
  /**
   * DOM
   */
  return (
    <ChakraUiIconButton
      data-object-type="core-icon-button"
      ref={ref}
      {...rest}
      aria-label={ariaLabel}
      icon={<CoreIcon {...icon} />}
      isActive={!!isActive}
      {...(isFullWidth && { width: 'full', flex: '1' })}
      size={size}
    />
  );
});
IconButton.displayName = 'IconButton';

export default withTooltip('IconButton')(IconButton);
